export function selectAutocompleteResults(resource) {
  return (state) => state.autocompleteResults.current[resource];
}